import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { CONTACT } from "@/data/site";

export default function CtaSection({
    overline = "Get Started",
    title = "Your Construction. Our Expertise.",
    description = "Speak directly with an experienced civil works consultant before you commit to a contractor, a quotation or a payment.",
}) {
    return (
        <section className="noise-overlay relative bg-navy py-20 lg:py-28" data-testid="cta-section">
            <div className="blueprint-grid-dark absolute inset-0" aria-hidden="true" />
            <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber">{overline}</p>
                    <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        {title}
                    </h2>
                    <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">{description}</p>
                    <div className="mt-8 flex flex-wrap gap-4">
                        <Link
                            to="/contact"
                            className="inline-flex items-center gap-2 bg-amber px-7 py-3.5 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-amber-hover"
                            data-testid="cta-book-consultation"
                        >
                            Book a Consultation <ArrowRight size={14} />
                        </Link>
                        <a
                            href={CONTACT.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 border border-slate-600 px-7 py-3.5 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:border-amber hover:text-amber"
                            data-testid="cta-whatsapp"
                        >
                            Chat on WhatsApp
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
